
(() => {
  function initMobileGallery() {
    document.querySelectorAll('.productView-images').forEach(gallery => {
      if (gallery.querySelector('#bilmedie-mobile-gallery')) return;

      const nav = gallery.querySelector('.productView-nav');
      if (!nav) return;

     const originals = [
  ...nav.querySelectorAll(
    '.productView-image:not(.slick-cloned) [data-fancybox="images"]'
  )
];
      const images = [...new Map(
        originals
          .filter(el => el.getAttribute('href'))
          .map(el => [el.getAttribute('href'), el])
      ).values()];

      if (!images.length) return;

      const panel = document.createElement('div');
      panel.id = 'bilmedie-mobile-gallery';

      const track = document.createElement('div');
      track.className = 'bilmedie-mobile-track';

      images.forEach((source, index) => {
        const img = document.createElement('img');

        img.src =
          source.querySelector('img')?.currentSrc ||
          source.querySelector('img')?.src ||
          source.getAttribute('href');

        img.alt =
          source.querySelector('img')?.alt ||
          `Produktbillede ${index + 1}`;

        img.loading = index < 2 ? 'eager' : 'lazy';
        img.className = 'bilmedie-mobile-image';

        img.addEventListener('click', () => {
          source.click();
        });

        track.appendChild(img);
      });

      panel.appendChild(track);
      gallery.prepend(panel);
    });
  }

  function scheduleInit() {
    requestAnimationFrame(() => {
      initMobileGallery();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  window.addEventListener('load', scheduleInit);
})();
